export default "__VITE_ASSET__Dnr7X93A__"